const backURL = "https://pyatnashka.md/api_2";
// "http://194.156.67.209";

// "http://localhost:1198/api_2";

const backPort = ":1198";

const baseURL = `${backURL}/client`;

const endpoints = {
  login: `${backURL}/api/login`,
  auth: `${backURL}/api/auth/user`,
  bilet: `${baseURL}/bilet`,
  biletQuestions: `${baseURL}/bilet/init-test`,
  biletFinish: `${baseURL}/bilet/finish-test`,
  biletCancele: `${baseURL}/bilet/cancele-test`,
  log: `${baseURL}/log`,
  theme: `${baseURL}/bilet/theme`,
  video: `${backURL}/video`,
  image: `${backURL}/image`,
  // image: `http://194.156.67.209:1198/image`,
  stat: `${baseURL}/stat`,
  pdd: `${baseURL}/pdd`,
  progress: `${baseURL}/progress`,
  news: `${baseURL}/news`,
};

const VIDEO_CHUNK_SIZE = 10 ** 6;
export { endpoints, VIDEO_CHUNK_SIZE };
